import useQuery from "@/hooks/useQuery";
import { DASHBOARD_STATS_URL } from "@/common/constants";
import { PageSkeletonLoader } from "@/common/components/skeleton/page-skeleton";
import { RetailerStats } from "./subs/retailerStats";
import { useEffect, useState } from "react";
import { DistributorStats } from "./subs/distrubutorStats";
import { ManufacturerStats } from "./subs/manufacturerStat";
import { StateMinistryStats } from "./subs/stateMinistryStat";
import NoUser from "./subs/noUser";

export interface IStatsProps {}
export function Stats(_: IStatsProps) {
  const { loading } = useQuery(DASHBOARD_STATS_URL);

  const [user, setUser] = useState("");

  useEffect(() => {
    const storedData = localStorage.getItem("user");

    if (storedData) {
      const userData = JSON.parse(storedData);
      setUser(userData?.user_company_type);
    }
  }, []);

  const renderPage = () => {
    switch (user) {
      case "Retailer":
        return <RetailerStats />;
      case "Distributor":
        return <DistributorStats />;
      case "Manufacturer":
        return <ManufacturerStats />;
      case "Importer":
        return <ManufacturerStats />;
      // TODO: Update to Correct Role On integration
      case "ministry-admin":
        return <div>DG Ministry</div>;
      // TODO: Update to Correct Role On integration
      case "state-ministry":
        return <StateMinistryStats />;
      default:
        return <NoUser />;
    }
  };

  if (loading) return <PageSkeletonLoader />;
  return <>{renderPage()}</>;
}
